import { gql, useApolloClient } from '@apollo/client';
import {
  GetSuggestedCategoryQuery,
  GetSuggestedCategoryQueryVariables,
} from '../../__generated__/queries-web';

const SUGGEST_CATEGORIES = gql`
  query GetSuggestedCategory(
    $article: ArticleLikeInput!
    $first: UnsignedInt!
  ) {
    suggestCategories(article: $article, first: $first) {
      childCount
      children(first: $first) {
        id
        title
        slug
        format
        level
      }
    }
  }
`;

export const useSuggestedCategoriesGetter = () => {
  const client = useApolloClient();

  return ({ article, first }: GetSuggestedCategoryQueryVariables) =>
    client.query<GetSuggestedCategoryQuery, GetSuggestedCategoryQueryVariables>(
      {
        query: SUGGEST_CATEGORIES,
        variables: {
          first,
          article: {
            id: article?.id,
            brandKey: article?.brandKey,
            format: article?.format,
            title: article?.title,
            lead: article?.lead,
            body: article?.body,
          },
        },
      },
    );
};
